import { render } from "./MatchOfficialsSlots.vue?vue&type=template&id=3c4fd28f&scoped=true"
import script from "./MatchOfficialsSlots.vue?vue&type=script&lang=js"
export * from "./MatchOfficialsSlots.vue?vue&type=script&lang=js"

import "./MatchOfficialsSlots.vue?vue&type=style&index=0&id=3c4fd28f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4fd28f"]])

export default __exports__